// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__gmwrq","choiceBoxes":"toolbarselects_choiceBoxes__1M6mE","simpleField":"toolbarselects_simpleField__PJwzu"};